import { render, staticRenderFns } from "./dialog-selector.vue?vue&type=template&id=0b339af0&"
import script from "./dialog-selector.vue?vue&type=script&lang=js&"
export * from "./dialog-selector.vue?vue&type=script&lang=js&"
import style0 from "./dialog-selector.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports